<template>
  <div class="content">
    <div class="container">
      <section class="my-5">
        <row-section-header>
          <span slot="title">
            <h1>Motion Gallery</h1>
          </span>
        </row-section-header>
      </section>
      <section class="my-5">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 p-3">
            <row-section-header>
              <span slot="title">
                <h2>Lottie</h2>
              </span>
            </row-section-header>
            <p>
              Merging the world of design and motion through a deep understanding of After Effects and <a href="https://airbnb.design/lottie/" target="_blank">Lottie</a>.
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 bg-dark border rounded border-white p-3" v-for="(lottie, index) in lotties" :data-imageattr="lottie.attr">
            <keep-alive>
              <async-animation :async-anim-props="{ name: lottie.name, delay: index * 500, onComplete: 'loop', hasPlayer: 1, playerHeight: colWidth }"></async-animation>
            </keep-alive>
          </div>
        </div>
      </section>
      <section class="my-5">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 p-3">
            <row-section-header>
              <span slot="title">
                <h2>Webm</h2>
              </span>
            </row-section-header>
            <p>
              Web integrated video incorporating effects and methods not yet compatible with Lottie
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 bg-light border rounded border-white p-3" v-for="(webm, index) in webmFiles">
            <video width="100%" height="auto" muted playsinline autoplay loop>
              <source :src="webm.src" type="video/mp4">
            </video>
          </div>
        </div>
      </section>
      <section class="my-5">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 p-3">
            <row-section-header>
              <span slot="title">
                <h2>Videos</h2>
              </span>
            </row-section-header>
            <p>
              Did you know? 4 times as many consumers prefer to watch a video than to read about it. <small>(<a href="https://animoto.com/blog/business/video-marketing-cheat-sheet-infographic/" target="_blank">source: animoto</a>)</small>
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 bg-light border rounded border-white" v-for="(video, index) in videos">
            <div class="v-align-wrapper" :style="{height: colWidth}">
              <div class="v-align">
                <iframe :src="video.src" width="100%" height="auto" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 p-3">
            <div class="v-align-wrapper" :style="{height: colWidth}">
              <div class="v-align text-center">
                <a href="https://www.linkedin.com/in/stephanietaniguchi/" target="_blank">
                  <img class="img icon p-4" src="@/../static/ICONLinkedIN.svg" alt="location" style="width:100px">
                </a>
								<a href="stephanie.taniguchi@gmail.com?Subject=Hey,%20Stephanie" target="_top">
									<img class="img icon p-4" src="@/../static/ICONEmail.svg" alt="email" style="width:100px">
								</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 p-3" ref="col" style="min-height: 0"></div>
      </div>
    </div>
    <steph-footer></steph-footer>
  </div>
</template>

<script>
import AsyncAnimation from '@/components/AsyncAnimation.vue'
import RowSectionHeader from '@/components/rows/SectionHeader.vue'
import StephFooter from '@/components/StephFooter.vue'

export default {
  name: 'gallery',
  components: {
    AsyncAnimation,
    RowSectionHeader,
    StephFooter,
  },
  data: function () {
    return {
      colWidth: 0,
      lotties: [
        {
          name: 'heroAnim',
        },
        {
          name: 'vennAnim',
        },
        {
          name: 'aboutAnim',
        },
        {
          name: 'contactAnim',
        },
        {
          name: 'projectsAnim',
        },
        {
          name: 'inputMethodsAnim',
        },
        {
          name: 'fileSavingAnim',
        },
        {
          name: 'storeGoalsAnim',
        },
        {
          name: 'bearAnim',
          attr: 'bgD6BD09',
        },
        {
          name: 'bearAnim',
          attr: 'bgE00051',
        },
        {
          name: 'bearAnim',
          attr: 'bg222222',
        },
      ],
      webmFiles: [
        {
          src: '@/../static/3D-Objects1.webm',
        },
        {
          src: '@/../static/3D-Objects2.webm',
        },
      ],
      videos: [
        {
          src: 'https://player.vimeo.com/video/181406728',
        },
        {
          src: 'https://player.vimeo.com/video/253380149',
        },
        {
          src: 'https://player.vimeo.com/video/178370841',
        },
        {
          src: 'https://www.youtube.com/embed/M0bJQMzpx4U',
        },
      ],
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    this.getColWidth()
  },
  methods: {
    getColWidth: function () {
      this.colWidth = (this.$refs['col']) ? (this.$refs['col'].clientWidth - 30) + 'px' : '100%'
    },
    handleResize: function () {
      this.getColWidth()
    },
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>
<style lang="scss">
.async-anim-player {
  .async-anim-controller {
    position: absolute;
    bottom: 1rem;
    right: 2rem;
    font-size: 2.5rem;
    transition: opacity 0.5s ease;
    color: white;
    opacity: .5;
    &:hover, &:focus {
      opacity: 1;
    }
  }
}

html {
  position: relative;
  min-height: 100%;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  text-align: left;
  color: #2c3e50;
}

div.content {
  margin-bottom: 180px;
}

a {
  color: #42b983;
}

.serif {
  font-family: 'Rufina', Times, Palatino, serif;
}

.v-align-wrapper {
  position: relative;
  .v-align {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

.bg-dark[data-imageattr=bgD6BD09] {
  background-color: #D6BD09!important;
}
.bg-dark[data-imageattr=bgE00051] {
  background-color: #E00051!important;
}
.bg-dark[data-imageattr=bg222222] {
  background-color: #222222!important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Gallery.vue